import { render, staticRenderFns } from "./commonAttendanceRecords.vue?vue&type=template&id=61b12688&scoped=true"
import script from "./commonAttendanceRecords.vue?vue&type=script&lang=js"
export * from "./commonAttendanceRecords.vue?vue&type=script&lang=js"
import style0 from "./commonAttendanceRecords.vue?vue&type=style&index=0&id=61b12688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b12688",
  null
  
)

export default component.exports